<template>
    <div class="user-import h:margin-bottom-12">
        <stepper-step :number="0" :next-enabled="!!client.id">
            <user-import-client-select @change="(client) => this.client = client" :jobs-running="jobsRunning">
            </user-import-client-select>
        </stepper-step>

        <stepper-step :number="1" :next-enabled="!!usersToBeImported.length">
            <user-import-upload :client="client" @users-to-be-imported-changed="users => updateUsers(users)" :jobs-running="jobsRunning">
            </user-import-upload>
        </stepper-step>

        <stepper-step
            :number="2"
            :checkBeforeGoToNext="checkAssignmentsFormFields"
        >
            <user-import-assignments
                :client="client"
                :users-to-be-imported="usersToBeImported"
                :errors="assignmentsErrors"
                @assigned-courses-changed="courses => updateCourses(courses)"
                @assigned-usergroups-changed="usergroups => updateUsergroups(usergroups)">
            </user-import-assignments>
        </stepper-step>

        <stepper-step is-last-step :number="3" :show-buttons-above="true">
            <user-import-summary
                :users-to-be-imported="usersToBeImported"
                :client="client"
                :assigned-courses="assignedCourses"
                :assigned-usergroups="assignedUsergroups"
            ></user-import-summary>
        </stepper-step>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';
export default {
    props: {
        preselectedClient: {
            type: Object
        }
    },


    data() {
        return {
            file: null,
            client: this.preselectedClient.id ? this.preselectedClient : {},
            usersToBeImported: [],
            assignedCourses: [],
            assignedUsergroups: [],
            loading: false,
            assignmentsErrors: {},
            jobsRunning: false,
        };
    },

    computed: {
        skipFirstStep() {
            // A preselected client exists
            return !!this.preselectedClient.id;
        },


        fileValid() {
            return !!this.file;
        },
    },

    methods: {
        updateUsers(users) {
            this.usersToBeImported = users;
            EventBus.$emit('users-to-be-imported-changed', this.usersToBeImported);
        },

        updateCourses(courses) {
            this.assignedCourses = courses;
        },

        updateUsergroups(usergroups) {
            this.assignedUsergroups = usergroups;
        },

        checkAssignmentsFormFields() {
            var user_groups =  this.formatUserGroupsForBackend();
            var courses = this.formatUserCoursesForBackend();

            return axios.post(this.route('tenantapi.user-import.validate'), {
                'client_id': this.client.id,
                'user_groups': user_groups,
                'courses': courses,
                'count_users': this.usersToBeImported.length
            }).then(response => {
                    this.assignmentsErrors = {};
                    return true;
                })
                .catch((error) => {
                    this.assignmentsErrors = error.response.data.errors;
                    return false;
                });
        },


        formatUserGroupsForBackend() {
            var user_groups =  [];

            this.assignedUsergroups.forEach((userGroup, index) => {
                user_groups[index] = {};
                user_groups[index].user_group_id = userGroup.user_group ? userGroup.user_group.id : null

                // Add following fields only if they are set.
                if (userGroup.user_group.courses.length) {
                    user_groups[index].client_id = userGroup.client ? userGroup.client.id : null
                    user_groups[index].start_date = userGroup.start_date || null;
                    user_groups[index].end_date = userGroup.end_date || null;
                }
            });

            return user_groups;
        },

        formatUserCoursesForBackend() {
            var courses = [];

            this.assignedCourses.forEach((course, index) => {
                courses[index] = {};
                courses[index]['course_id'] = course.course ? course.course.id : null;
                courses[index]['client_id'] = course.client ? course.client.id : null;
                courses[index]['start_date'] = course.start_date ? course.start_date : null;
                courses[index]['end_date'] = course.end_date ? course.end_date : null;
            });
            return courses;
        },

        // We need to check if other jobs are still running to show a warning
        checkForRunningJobs() {
            axios.get(this.route('tenantapi.jobs.check.user_import'))
                .then(response => {
                    if (response.data.count) {
                        this.jobsRunning = true;
                        setTimeout(() => {
                            this.checkForRunningJobs();
                        }, 5000);
                    } else {
                        this.jobsRunning = false;
                    }
                })
                .catch((error) => {
                    console.log('error');
                });

            return;
        },
    },

    mounted() {
        this.checkForRunningJobs();

        if(this.skipFirstStep) {
            EventBus.$emit('changeStepperTo', 1);
        }

        EventBus.$on('databaseChanged', () => location.reload());
    }
};
</script>
